import CollectionContainer from '../containers/Collection';

class PageSearchResults extends CollectionContainer {
  constructor() {
    super();
    super.init();
  }

  init() {
    console.log('UNTUCKit : Template : PageSearchResults', this);
  }
}

$(() => {
  new PageSearchResults();
});
